import React, { SetStateAction, useState } from 'react';
import { Button, Form, Modal } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

import { useHrCloseMutation, useRejectRefMutation } from 'app/services/edpApiV1/references';

import { useNotifications } from 'shared/hooks/use-notifications';
import { TUnionTableData } from 'shared/types/types';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import { useAppSelector } from 'app/store';

type TProps = {
  id: string | undefined;
  label: string;
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectUser?: React.Dispatch<SetStateAction<TUnionTableData>>;
};

export const ReferenceModal = ({ openModal, setOpenModal, id, label, setSelectUser }: TProps) => {
  const [modalText, setModalText] = useState<string>();
  const [form] = Form.useForm();
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const [rejectRefTrigger, resultRejectRef] = useRejectRefMutation();
  const [closeHrTrigger, setHrClose] = useHrCloseMutation();
  const { isSuccess: rejectSuccess, isError: errorReject, reset: resetReject } = resultRejectRef;
  const { isSuccess: closeSuccess, isError: closeReject, reset: resetClose } = setHrClose;

  const handleOk = () => {
    if (modalText && id && label === 'rejection') {
      rejectRefTrigger({ requestId: Number(id), rejectionReason: modalText, allAvailableOrganizations });
      setOpenModal(false);
      // скрываю кнопки 'Отклонить' 'Подробнее', 'Готова к выдаче'
      if (setSelectUser) setSelectUser([]);
    }
    if (modalText && id && label === 'close') {
      closeHrTrigger({ requestId: id, allAvailableOrganizations });
      setOpenModal(false);
      // скрываю кнопки 'Отклонить' 'Подробнее', 'Готова к выдаче'
      if (setSelectUser) setSelectUser([]);
    }
  };

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    // если отсутствует текст, игнорирую пробелы и переносы строки клавищей "ENTER"
    if (!modalText) {
      setModalText(e.target.value.replace(/^\s+/g, ''));
    } else {
      setModalText(e.target.value);
    }
  };

  const handleCancel = () => {
    setOpenModal(false);
    setModalText('');
    form.resetFields(['rejectionReason']);
  };

  useNotifications(rejectSuccess, errorReject, 'Заявление успешно отклонено', 'Что-то пошло не так', resetReject);
  useNotifications(closeSuccess, closeReject, 'Заявление успешно закрыто', 'Что-то пошло не так', resetClose);

  return (
    <Modal
      title="Напишите причину отказа"
      visible={openModal}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Отмена
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk} disabled={!modalText}>
          Отправить
        </Button>,
      ]}
    >
      <Form name="rejectionForm" form={form}>
        <Form.Item rules={[{ required: true, message: 'Пожалуйста, введите текст' }]}>
          <TextArea
            showCount
            name="rejectionReason"
            value={modalText}
            onChange={onChange}
            required
            placeholder="Причина отказа"
            rows={8}
            maxLength={300}
            minLength={1}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
